export type AnimationEffect = "fade" | "fade-blur";
export type AnimationType =
  | "fade"
  | "fade-up"
  | "fade-down"
  | "fade-left"
  | "fade-right";
export type AnimationSpeed = "slow" | "normal" | "fast";
export type AnimationDevices = "all" | "desktop" | "mobile";

export interface BlockAnimation {
  animationEnabled?: boolean;
  animationEffect?: AnimationEffect;
  animationType?: AnimationType;
  animationSpeed?: AnimationSpeed;
  animationDevices?: AnimationDevices;
}

const ANIMATION_TYPES: AnimationType[] = [
  "fade",
  "fade-up",
  "fade-down",
  "fade-left",
  "fade-right",
];
const ANIMATION_SPEEDS: AnimationSpeed[] = ["slow", "normal", "fast"];

export interface AnimationAttributes {
  "data-af-anim": string;
  "data-af-anim-speed": string;
  "data-af-blur"?: string;
  "data-af-anim-only"?: string;
}

export function getAnimationAttributes({
  animationEnabled,
  animationEffect,
  animationType,
  animationSpeed,
  animationDevices,
}: BlockAnimation): AnimationAttributes | null {
  if (!animationEnabled) return null;

  const type =
    animationType && ANIMATION_TYPES.includes(animationType)
      ? animationType
      : "fade";
  const speed =
    animationSpeed && ANIMATION_SPEEDS.includes(animationSpeed)
      ? animationSpeed
      : "normal";

  const attributes: AnimationAttributes = {
    "data-af-anim": type,
    "data-af-anim-speed": speed,
  };

  if (animationEffect === "fade-blur") {
    attributes["data-af-blur"] = "";
  }

  if (animationDevices === "desktop" || animationDevices === "mobile") {
    attributes["data-af-anim-only"] = animationDevices;
  }

  return attributes;
}
